module.exports = __webpack_public_path__ + "static/media/toy-truck.9f77f66f.png";